export const isGatewayMethod = (method?: string) =>
  Boolean(method) && method !== "cod" && method !== "wallet";

export const paymentMethodLabel = (method?: string) => {
  if (method === "cod") return "Cash on Delivery";
  if (method === "wallet") return "Wallet";
  if (method) return method.charAt(0).toUpperCase() + method.slice(1);
  return "-";
};

export const roleTone = (role = "") => {
  if (role === "superadmin") return "warning";
  if (role === "manager") return "success";
  return "muted";
};

export const formatAdminRole = (role = "") =>
  role ? role.charAt(0).toUpperCase() + role.slice(1) : "—";

export const RANK_CLUBS = ["Leader", "Director", "Partner", "Royalty"] as const;
export const MATRIX_SEQUENCE = [1, 2, 3, 4, 5, 6];
export const PROGRESS_SEQUENCE = [...MATRIX_SEQUENCE, ...RANK_CLUBS];
export const rankKey = (club: unknown): string | null => {
  const key = String(club ?? "").trim().toLowerCase();
  return RANK_CLUBS.some(name => name.toLowerCase() === key) ? key : null;
};

export const clubLevel = (club: unknown) => {
  const n = Number(club);
  return Number.isInteger(n) && n >= 1 && n <= 6 ? n : 1;
};

export const clubLabel = (club: unknown) => {
  const key = String(club ?? "").trim().toLowerCase();
  const rank = RANK_CLUBS.find((name) => name.toLowerCase() === key);
  if (rank) return rank;
  return `Club ${clubLevel(club)}`;
};

export const orderStatusTone = (status = "") => {
  if (["Delivered", "Refunded", "Return Approved"].includes(status)) {
    return "success";
  }
  if (["Processing", "Shipped", "Return Requested"].includes(status)) {
    return "warning";
  }
  if (["Cancelled", "Return Rejected"].includes(status)) {
    return "danger";
  }
  return "muted";
};
